import React from "react";

const Loader = () => {
  return (
    <div className="tc-custom-loader">
      <div className="loader"></div>
    </div>
  );
};

export default Loader;
